import ReactPaginate from 'react-paginate';
import Skeleton from 'react-loading-skeleton';
import { Col, Row } from 'reactstrap';

export const TablePagination = ({ limit, page, currentRecords, total, onPaginationChange, loading }) => {
    const pageCount = Math.ceil(total / limit);  // Calculate the total number of pages

    return (
        <Row className="align-items-center">
            <Col md="6">
                {
                    loading ?
                        <Skeleton width={300} height={22} className="mt-1" /> :
                        <span className="fs-12 fw-400 text-light align-middle">
                            Showing {total ? (limit * (page - 1)) + 1 : 0} to {(limit * (page - 1)) + currentRecords} of {total} Results
                        </span>
                }
            </Col>
            <Col md="6" className="d-flex justify-content-end">
                {
                    loading ?
                        <Skeleton width={250} height={40} /> :
                        <nav>
                            <ReactPaginate
                                pageCount={pageCount}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={1}
                                onPageChange={({ selected }) => onPaginationChange(selected + 1)} // react-paginate uses 0-indexed pages
                                containerClassName="pagination m-0"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                nextClassName="page-item"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                activeClassName="active"
                                disabledClassName="disabled"
                                nextLinkClassName="page-link next-item"
                                previousLinkClassName="page-link previous-item"
                                nextLabel={<i className='ri-arrow-right-s-line'></i>}
                                previousLabel={<i className='ri-arrow-left-s-line'></i>}
                                forcePage={page - 1} // react-paginate uses 0-indexed pages
                            />
                        </nav>
                }
            </Col>
        </Row>
    );
};